import AxiosInstance from 'config/apiServiceApiGateway'
import { Get } from 'config/apiServiceConfig'
import {
  CheckedRlType,
  DeleteReasonType,
  RlSourcingFilterType,
  GetReorderListResponseType,
  UpdateRlVendorDetailType,
  DeleteVendorPayloadType,
  VendorCatalogPayloadType,
  SaveRlRequestType,
  GetRequestUpdateResponseType,
  RequestUpdateDetailsType,
  RequestChangesPayloadType,
  VendorCatalogType,
  TableCheckedRlType,
  RequestChangeVendorStatusListType,
  ProductVendorType,
  ReorderListUOMResponseType,
} from '../types/rlSourcing'

export const fetchRlSourcingApi = (params: RlSourcingFilterType) =>
  AxiosInstance.Get<GetReorderListResponseType, true>({
    url: `/commercial/internal/:version/reorder-list`,
    version: 'v2',
    params,
  })

export const fetchDeleteReasonsApi = () =>
  AxiosInstance.Get<{ data: DeleteReasonType[] }, true>({
    url: `/commercial/internal/v1/reason/REORDER_LIST`,
  })

export const updateVendorRlDetailApi = (reorderListId: number, data: UpdateRlVendorDetailType) =>
  AxiosInstance.Put({
    url: '/commercial/internal/:version/reorder-list/vendor/:reorderListId',
    urlParams: { reorderListId },
    data,
    version: 'v1',
  })

export const deleteVendorsApi = (data: DeleteVendorPayloadType) =>
  AxiosInstance.Put({
    url: `/commercial/internal/:version/reorder-list/vendors/delete`,
    version: 'v2',
    data,
  })

export const updateVendorCatalogsApi = (id: number, data: VendorCatalogPayloadType[]) =>
  AxiosInstance.Put({
    url: '/commercial/internal/:version/reorder-list/vendor/upsert/:id',
    version: 'v1',
    urlParams: { id },
    data: { data },
  })

export const fetchPODraftTotalApi = () =>
  AxiosInstance.Get<{ data: { total_po_draft: number } }, true>({
    url: `/commercial/internal/:version/po-draft/total`,
    version: 'v1',
  })

export const fetchCheckedRlApi = () =>
  AxiosInstance.Get<{ data: { reorder_list_vendors: CheckedRlType[] } }, true>({
    url: '/commercial/internal/:version/reorder-list/vendor/checked',
    version: 'v1',
  })

export const saveRlApi = (data: SaveRlRequestType[]) =>
  AxiosInstance.Put<{ data: { reorder_list_detail: TableCheckedRlType[] } }, true>({
    url: `/commercial/internal/v2/reorder-list/save`,
    data: { data },
  })

export const postRequestChangesApi = (id: number, data: RequestChangesPayloadType) =>
  AxiosInstance.Post({
    url: '/commercial/internal/:version/reorder-list/:id/changes',
    version: 'v1',
    urlParams: { id },
    data,
  })

export const fetchRequestUpdateApi = (params: RlSourcingFilterType) =>
  AxiosInstance.Get<GetRequestUpdateResponseType, true>({
    url: `/commercial/internal/:version/reorder-list/changes`,
    version: 'v1',
    params,
  })

export const fetchRequestChangeDetailsApi = (id: number) =>
  AxiosInstance.Get<{ data: RequestUpdateDetailsType }, true>({
    url: `/commercial/internal/:version/reorder-list/changes/:id`,
    version: 'v1',
    urlParams: { id },
  })

export const fetchVendorCatalogsApi = (productId: number) =>
  Get<{ data: VendorCatalogType[] }>({
    url: '/api/product/:productId/catalogs',
    urlParams: { productId },
    params: { pageSize: '99' },
  })

export const downloadRlApi = () =>
  AxiosInstance.Get<{ data: { url: string } }, true>({
    url: '/commercial/internal/:version/reorder-list/changes/download',
    version: 'v1',
  })

export const fetchVendorRequestChagesStatusApi = (vendor_ids: string) =>
  AxiosInstance.Get<{ data: { vendors: RequestChangeVendorStatusListType[] } }, true>({
    url: '/commercial/internal/:version/reorder-list/vendor-status',
    version: 'v1',
    params: { vendor_ids },
  })

export const getProductVendorsApi = (product_id: number) =>
  AxiosInstance.Get<{ data: ProductVendorType[] }, true>({
    url: '/commercial/internal/:version/product-vendors',
    version: 'v1',
    params: {
      page_size: '999',
      product_id,
    },
  })

export const getProductVendorFeatureFlagApi = () =>
  AxiosInstance.Get<{ data: { FF_ENABLE_VENDOR_CATALOG_MIGRATION_ALLOYDB: string } }, true>({
    url: '/commercial/internal/:version/feature-flags?flags=FF_ENABLE_VENDOR_CATALOG_MIGRATION_ALLOYDB',
    version: 'v1',
  })

export const fetchUOMs = () =>
  Get<ReorderListUOMResponseType>({
    url: `/api/uoms?groups=ITEM&pageSize=100`,
  })
